import { Component, OnInit } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { WizardStepBaseComponent } from '../wizard-step-base/wizard-step-base.component';

@Component({
  selector: 'app-personal-info-wizard-step',
  templateUrl: './personal-info-wizard-step.component.html',
  styleUrls: ['./personal-info-wizard-step.component.scss']
})
export class PersonalInfoWizardStepComponent extends WizardStepBaseComponent implements OnInit {
  public readonly datepickerConfig: Partial<BsDatepickerConfig> = {
    showWeekNumbers: false,
    dateInputFormat: 'DD.MM.YYYY',
    useUtc: false,
  };

  ngOnInit(): void {
    const birthdayControl = this.getFormControl('birthday');
    if (birthdayControl) {
      birthdayControl.valueChanges.subscribe((value) => {
        if (value instanceof Date) {
          const normalized = new Date(
            value.getFullYear(),
            value.getMonth(),
            value.getDate(),
            23, 20, 0
          );

          birthdayControl.setValue(normalized, { emitEvent: false });
        }
      });
    }
  }
}
